// @flow
import React, { PureComponent } from 'react';
import { getMonthName } from 'utils/dateUtils';
import { dynamicClassName } from 'utils/dynamicClassName';
import DropdownRadioInput from 'components/fragments/input/DropdownRadioInput';
import MenuElement from 'components/header/MenuElement';
import MenuElementPlus from 'components/header/MenuElementPlus';
import { SORT_DATE, SORT_NAME } from 'constants/sortConstants';
import { EVENT_LIST_OPTIONS } from 'constants/eventConstants';

type Props = {
  currentMonth: Date,
  labels: Array<string>,
  handleLinkClicked: (label: ?string) => void,
  handleSortChanged: (sort: SORT_DATE | SORT_NAME) => void
};

type State = {
  menuItems: Array<{ id: number, size: number }>,
  isMobile: boolean,
  hiddenMenuItems: Array<number>,
  menuElements: Array<MenuElement>,
  menuLinkX: number,
  activeLink: ?string
};

class EventListNavbar extends PureComponent<Props, State> {
  props: Props;
  _menuElements: Array<?MenuElement>;
  _menu: ?HTMLElement;
  _menuLink: ?HTMLElement;
  _menuTous: ?HTMLElement;
  _menuFilter: ?HTMLElement;
  state: State = {
    menuItems: [],
    isMobile: false,
    hiddenMenuItems: [],
    menuElements: [],
    menuLinkX: 0,
    activeLink: null
  };

  constructor(props: Props) {
    super(props);
    this._menuElements = [];
    this.handleLinkClicked = this.handleLinkClicked.bind(this);
  }

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions.bind(this));
  }

  componentDidUpdate() {
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions.bind(this));
  }

  updateDimensions() {
    const menu = this._menu;
    const menuLink = this._menuLink;
    const menuTous = this._menuTous;
    const menuFilter = this._menuFilter;
    if (menu && menuLink && menuFilter && menuTous) {
      const width_menu_links = this._menuElements.reduce(
        (total, item) => (item ? total + item.getSize() * (window.innerWidth <= 1280 ? 1.12 : 1.2) : total),
        0
      );
      const menuLinkX = menuFilter.offsetWidth - menuLink.offsetWidth;
      if (menuLinkX !== this.state.menuLinkX) this.setState({ menuLinkX });
      const maxWidth = menu.offsetWidth;
      const width_tous = menuTous.offsetWidth;

      const totalWidth = width_menu_links + width_tous;
      let currentWidth = totalWidth + 50;
      let deleted = [];
      if (maxWidth > 522) {
        for (let i = this._menuElements.length - 1; i > 0; i--) {
          if (currentWidth > maxWidth) {
            if (this._menuElements[i]) currentWidth -= this._menuElements[i].getSize();
            deleted = [...deleted, i];
          }
        }
        if (this.state.isMobile) this.setState({ isMobile: false });
      } else {
        if (!this.state.isMobile) this.setState({ isMobile: true });
      }
      if (
        (deleted.length !== this.state.hiddenMenuItems.length &&
          (deleted.length > 0 || this.state.hiddenMenuItems.length > 0) &&
          !deleted.every(id => this.state.hiddenMenuItems.includes(id))) ||
        !this.state.hiddenMenuItems.every(id => deleted.includes(id))
      ) {
        this.setState({ hiddenMenuItems: deleted });
      }
    }
  }

  resetMenuElementRef = (c: ?MenuElement) => {
    this._menuElements = [];
    this.addMenuElementRef(c);
  };

  addMenuElementRef = (c: ?MenuElement) => {
    this._menuElements.push(c);
  };

  isDisplayed = (id: number) => {
    return !this.state.hiddenMenuItems.includes(id);
  };

  handleLinkClicked = (label: ?any, e: any) => {
    if (label === 10) {
      label = e.target.text;
    }
    if (e) {
      e.preventDefault();
    }
    this.setState({ activeLink: label });
    this.props.handleLinkClicked(label);
  };

  getLabelClassName = (label: ?string) => {
    const classNamesLabel = dynamicClassName('');
    this.state.activeLink === label && classNamesLabel.add('is-active');
    return classNamesLabel.build();
  };

  renderLabels = (): any => {
    return this.props.labels.map((label, index) => (
      <MenuElement
        key={label}
        url={`/evenements/`}
        title={label}
        isMobile={true}
        ref={index === 0 ? this.resetMenuElementRef : this.addMenuElementRef}
        id={index}
        onClick={this.handleLinkClicked.bind(this, label)}
        isDisplayed={this.isDisplayed}
        menuX={this.state.menuLinkX}
        isActive={this.state.activeLink === label}
      />
    ));
  };

  render() {
    const hiddenMenuElements = this.state.hiddenMenuItems.map(id => {
      return this._menuElements[id];
    });
    return (
      <React.Fragment>
        <div className="events__filter events__filter--ligue" ref={c => (this._menuFilter = c)}>
          <nav className="navbar" ref={c => (this._menu = c)}>
            <ul className="navbar__links" ref={c => (this._menuLink = c)}>
              <li ref={c => (this._menuTous = c)}>
                <a
                  role="button"
                  tabIndex={0}
                  onClick={this.handleLinkClicked.bind(this, null)}
                  title="Voir tous les événements"
                  className={this.getLabelClassName(null)}
                >
                  Tous les événements
                </a>
              </li>
              {this.renderLabels()}
              <MenuElementPlus
                hiddenMenuElements={hiddenMenuElements}
                isMobile={false}
                id={10}
                isDisplayed={this.isDisplayed}
                activateMenu={this.handleLinkClicked}
                text={'En voir plus'}
                menuX={this.state.menuLinkX}
                isNavbar
              />
            </ul>
          </nav>
          <DropdownRadioInput
            navBar={true}
            counter={0}
            id="Filters"
            isShadow
            options={[
              { value: null, label: 'Tous les événements' },
              ...this.props.labels.map(label => ({ value: label, label }))
            ]}
            inputChanged={this.handleLinkClicked}
          />
          <DropdownRadioInput
            prelabel={`${getMonthName(this.props.currentMonth.getMonth())} ${this.props.currentMonth.getFullYear()} : `}
            counter={0}
            id="Septembre 2018"
            isShadow
            labelIcon="icon-calendar"
            options={EVENT_LIST_OPTIONS}
            inputChanged={this.props.handleSortChanged}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default EventListNavbar;
